import ItemsBlock from './ItemsBlock.vue';

export * from './components';
export default ItemsBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/itemsblock/index.ts